"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/fanclub/v1/internal_service.proto (package spwn.fanclub.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalFanclubServiceGetPlansByBrandIdResponse = exports.InternalFanclubServiceGetPlansByBrandIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const internal_common_pb_1 = require("./internal_common_pb");
/**
 * @generated from message spwn.fanclub.v1.InternalFanclubServiceGetPlansByBrandIdRequest
 */
class InternalFanclubServiceGetPlansByBrandIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalFanclubServiceGetPlansByBrandIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalFanclubServiceGetPlansByBrandIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalFanclubServiceGetPlansByBrandIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalFanclubServiceGetPlansByBrandIdRequest, a, b);
    }
}
exports.InternalFanclubServiceGetPlansByBrandIdRequest = InternalFanclubServiceGetPlansByBrandIdRequest;
InternalFanclubServiceGetPlansByBrandIdRequest.runtime = protobuf_1.proto3;
InternalFanclubServiceGetPlansByBrandIdRequest.typeName = "spwn.fanclub.v1.InternalFanclubServiceGetPlansByBrandIdRequest";
InternalFanclubServiceGetPlansByBrandIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.fanclub.v1.InternalFanclubServiceGetPlansByBrandIdResponse
 */
class InternalFanclubServiceGetPlansByBrandIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.fanclub.v1.InternalPlan plans = 1;
         */
        this.plans = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalFanclubServiceGetPlansByBrandIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalFanclubServiceGetPlansByBrandIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalFanclubServiceGetPlansByBrandIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalFanclubServiceGetPlansByBrandIdResponse, a, b);
    }
}
exports.InternalFanclubServiceGetPlansByBrandIdResponse = InternalFanclubServiceGetPlansByBrandIdResponse;
InternalFanclubServiceGetPlansByBrandIdResponse.runtime = protobuf_1.proto3;
InternalFanclubServiceGetPlansByBrandIdResponse.typeName = "spwn.fanclub.v1.InternalFanclubServiceGetPlansByBrandIdResponse";
InternalFanclubServiceGetPlansByBrandIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "plans", kind: "message", T: internal_common_pb_1.InternalPlan, repeated: true },
]);
//# sourceMappingURL=internal_service_pb.js.map